import { valueTypes } from "./ResultClasses";

export class Template {
    constructor(title, description, categories, categoryIds, properties, groupBy, searchValue, conditionalFormatting, customColumns) {
        this.userCreated = true;
        this.title = title; // string
        this.descreption = description; // string
        this.categories = categories; // [] of strings
        this.categoryIds = categoryIds; // [] of ints
        this.properties = properties; // [] of strings
        this.groupBy = groupBy; // [] of strings
        this.searchValue = searchValue; // string
        this.creationTime = Date.now();
        this.conditionalFormatting = conditionalFormatting; // object of type ColorConditions 
        this.customColumns = customColumns; // dictionary (js object) values are CustomColumn
    }
}

export class Collection {
    constructor(properties, groupedBy, customColumns) {
        this.title = "";
        this.descreption = "";
        this.creationTime = Date.now();
        this.properties = properties;
        this.groupBy = groupedBy;
        this.elements = [];
        this.color = ""; // 6 digits color string - rrggbb
        this.customColumns = customColumns; // dictionary (js object) values are CustomColumn
    }
}


export class BimsearchElement {
    constructor(elementModelId) {
        this.id = elementModelId;
        this.propertiesValues = new Object();
    }
}

export class ElementModelId {
    constructor(linkId, revitId) {
        this.linkId = linkId;
        this.revitId = revitId;
    }
}

export function modelIdToKey(elementModelId) {
    return elementModelId.linkId + "," + elementModelId.revitId;
}

export class customColumn {
    constructor() {
        this.columnCondition = "";
        this.advanceTabActive = false; // false if basic tab is active, true if advance
        this.currentTree = "";
        this.functionValue = "";
        this.newColumnName = "";
        this.variables = {}; // Dictionary (js object) Column name -> number
    }
}

export class ColorConditions {
    constructor() {
        this.colorColumnKey = 0;
        this.colorColumnType = valueTypes.unknown;
        this.conditions = []; // [] of ColorCondition 
        this.colorSchemeGradientData = null;
        this.gradientTabActive = false; // false if conditions, true if gradiant
    }
}

export class ColorSchemeGradientData {
    constructor() {
        this.firstValue = "";
        this.secondValue = "";
    }
}

export class ColorCondition {
    constructor() {
        this.color = "";
        this.type = conditionTypes.uniqueValue;
        this.inputsDataArray = []; // array of data fields as string
    }
}

export const conditionTypes = {
    uniqueValue: 0,
    empty: 1,
    notEmpty: 2,
    textContains: 3,
    textDoesNotContain: 4,
    textStartsWith: 5,
    textEndsWith: 6,
    textIsExactly: 7,
    moreThan: 8,
    moreThanOrEqualTo: 9,
    lessThan: 10,
    lessThanOrEqualTo: 11,
    equal: 12,
    notEqual: 13,
    isBetween: 14,
    isNotBetween: 15,
    dateIs: 16,
    dateIsBefore: 17,
    dateIsAfter: 18,
};
